module.exports = __webpack_public_path__ + "static/img/11.cf8dd702.png";